import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import "../assets/Css/header.css";
import "../index.css"
import logo from "../assets/images/dark.png";
import img1 from "../assets/images/n1.jpg";
import img2 from "../assets/images/n2.jpg";
import img3 from "../assets/images/n3.jpg"; 
import img4 from "../assets/images/n4.jpg";
import { Link } from "react-router-dom";

export default function Header() {
  const navContainerRef = useRef();

  useEffect(() => {
    const t1 = gsap.timeline({ paused: true });

    t1.to(navContainerRef.current, 1, {
      left: 0,
      ease: "expo.inOut",
    });


    t1.reverse();

    const openMenu = () => {
      t1.reversed(!t1.reversed());
    };

    document.querySelector(".menu-open").addEventListener("click", openMenu);

    const closeMenu = () => {
      t1.reversed(!t1.reversed());
    };

    document.querySelector(".menu-close").addEventListener("click", closeMenu);
// Add event listener to close the menu when a link is clicked
const menuLinks = document.querySelectorAll(".menu__item-link");
menuLinks.forEach((link) => {
  link.addEventListener("click", closeMenu);
});

  }, []);
  return (
    <>
      <header>
        <nav>
          <div className="nav-list destop-vw">
            <ul>
              {/* <li>
                <Link to="/team">Team</Link>
              </li> */}
              <li>
                <a href="https://prebuilttemplates.com/">Shopify App</a>
              </li>
            </ul>
          </div>
          <div className="nav-logo">
            <Link to="/"><img src={logo} alt="" /></Link>
     
          </div>
          <div className="nav-list destop-vw">
            <ul>
              {/* <li>
                <a href="#cases">Cases</a>
              </li> */}
              {/* <li>
                <a href="#">Contact</a>
              </li> */}
            </ul>
          </div>
          <div className="nav-list Mobol-vw">
            <div className="menu-open">menu</div>
            <div ref={navContainerRef} className="nav-container">
              <div className="menu-close">close</div>
              <div className="socials">
                <span>facebook</span>
                <span>instagram</span>
              </div>
              <nav className="menu">
                <div className="menu__item">
                  <Link className="menu__item-link" to="/Shopify-custom-sections">
                    Shopify App
                  </Link>
                  <img className="menu__item-img" src={img1} alt="Home" />
                  {/* <div className="marquee">
                    <div className="marquee__inner">
                      <span>
                      Team - Team - Team - Team - Team - Team - Team
                      </span>
                    </div>
                  </div> */}
                </div>
                {/* <div className="menu__item">
                  <a className="menu__item-link" href="#showcase">
                    Showcase
                  </a>
                  <img className="menu__item-img" src={img2} alt="Showcase" />
                  <div className="marquee">
                    <div className="marquee__inner">
                      <span>
                        Showcase - Showcase - Showcase - Showcase - Showcase -
                        Showcase
                      </span>
                    </div>
                  </div>
                </div> */}
                {/* <div className="menu__item">
                  <a className="menu__item-link" href="#about">
                    About
                  </a>
                  <img className="menu__item-img" src={img3} alt="About" />
                  <div className="marquee">
                    <div className="marquee__inner">
                      <span>
                        About - About - About - About - About - About - About
                      </span>
                    </div>
                  </div>
                </div> */}
                {/* <div className="menu__item">
                  <a className="menu__item-link" href="#contact">
                    Contact
                  </a>
                  <img className="menu__item-img" src={img4} alt="Contact" />
                  <div className="marquee">
                    <div className="marquee__inner">
                      <span>
                        Contact - Contact - Contact - Contact - Contact -
                        Contact - Contact
                      </span>
                    </div>
                  </div>
                </div> */}
              </nav>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}
